import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { transformFromString, transformToString as _transformToString } from "./transforms";
export var Uint8ArrayBlobAdapter = /*#__PURE__*/function (_Uint8Array) {
  _inherits(Uint8ArrayBlobAdapter, _Uint8Array);
  var _super = _createSuper(Uint8ArrayBlobAdapter);
  function Uint8ArrayBlobAdapter() {
    _classCallCheck(this, Uint8ArrayBlobAdapter);
    return _super.apply(this, arguments);
  }
  _createClass(Uint8ArrayBlobAdapter, [{
    key: "transformToString",
    value: function transformToString() {
      var encoding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "utf-8";
      return _transformToString(this, encoding);
    }
  }], [{
    key: "fromString",
    value: function fromString(source) {
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf-8";
      switch (typeof source) {
        case "string":
          return transformFromString(source, encoding);
        default:
          throw new Error("Unsupported conversion from ".concat(typeof source, " to Uint8ArrayBlobAdapter."));
      }
    }
  }, {
    key: "mutate",
    value: function mutate(source) {
      Object.setPrototypeOf(source, Uint8ArrayBlobAdapter.prototype);
      return source;
    }
  }]);
  return Uint8ArrayBlobAdapter;
}( /*#__PURE__*/_wrapNativeSuper(Uint8Array));